import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { __ANPR_PERSON_NEW_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponseListPayloadQuarkus } from 'shell/models/http-response';
import { ItemVM } from 'shell/view-models/item';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';

interface ResponseValidazione {
  key: {
    codice: string;
  };
  descrizione: string;
}

interface FlagValidationFiscalCodeProps {
  disabled?: boolean;
  error?: boolean;
  value: string;
  label: string;
  onChange: (event: SelectChangeEvent<string>) => void;
}

const FlagValidationFiscalCodeComponent = ({
  disabled,
  onChange,
  value,
  error,
  label,
}: FlagValidationFiscalCodeProps): React.ReactElement => {
  const [fiscalCodeValidation] = useHttpFetch<
    HttpResponseListPayloadQuarkus<ResponseValidazione>,
    Array<ItemVM>
  >(`${__ANPR_PERSON_NEW_API_URL__}/validazione-codice-fiscale`, {
    onBootstrap: true,
    initialData: [],
    options: {
      errorCatching: true,
      method: 'GET',
      loading: true,
    },
    transformer: (response) =>
      (response?.data?.payload || []).map((item) => ({
        id: item.key.codice,
        value: item.descrizione,
      })),
  });
  const flags = (fiscalCodeValidation.data as Array<ItemVM>) || [];
  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id="flag-validation-label">
        Flag validazione codice fiscale
      </InputLabel>
      <PmiSelect
        labelId="flag-validation-label"
        id="flag"
        name="flag"
        value={value}
        label={label}
        onChange={onChange}
        disabled={disabled}
        error={error}
      >
        {flags.map((flag: ItemVM) => (
          <MenuItem key={flag.id} value={flag.id}>
            {flag.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

FlagValidationFiscalCodeComponent.displayName = 'List Flag validation fiscal code component';

const FlagValidationFiscalCode = memo(FlagValidationFiscalCodeComponent);

export default FlagValidationFiscalCode as typeof FlagValidationFiscalCodeComponent;
